<template>
  <section class="d-flex justify-content-center align-items-center">
    <div>
      <h1 class="fs-30">404</h1>
      <slot>
        <p class="fs-8">Page not found </p>
      </slot>
    </div>
  </section>
</BasePage>
</template>

<script>
export default {
  name: 'Basic404',
}
</script>



// WEBPACK FOOTER //
// Basic404.vue?06fdbdc8